import { render, staticRenderFns } from "./monthlyWelfare.vue?vue&type=template&id=70444ada&scoped=true"
import script from "./monthlyWelfare.vue?vue&type=script&lang=js"
export * from "./monthlyWelfare.vue?vue&type=script&lang=js"
import style0 from "./monthlyWelfare.vue?vue&type=style&index=0&id=70444ada&scoped=true&lang=css"
import style1 from "./monthlyWelfare.vue?vue&type=style&index=1&id=70444ada&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70444ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70444ada')) {
      api.createRecord('70444ada', component.options)
    } else {
      api.reload('70444ada', component.options)
    }
    module.hot.accept("./monthlyWelfare.vue?vue&type=template&id=70444ada&scoped=true", function () {
      api.rerender('70444ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/monthlyWelfare.vue"
export default component.exports